export const Utils = {
  getTextColor: function (backColor) {
    var color =
      backColor.charAt(0) === "#" ? backColor.substring(1, 7) : backColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.55 ? "blackText" : "whiteText"; //L > 0.179
  },

  presetThemeColors: [
    //#ffeb33
    [
      "#8bcf89",
      "#64a9d2",
      "#6980ba",
      "#9878b8",
      "#fb966a",
      "#fff066",
      "#c0ba99",
    ],
    [
      "#cdeacc",
      "#bddbec",
      "#bdc7e1",
      "#d1c5e0",
      "#fed1be",
      "#fff5a4",
      "#dedbcb",
    ],
  ],
  // presetThemeColors: [
  //     ['#21B14D', '#22D0EE', '#0153B8', '#812FA4', '#F15F10', '#ECD502', '#717171'],
  //     ['#89E8A2', '#89EFFE', '#58A3FE', '#CD9AE2', '#FABE9E', '#FEEF6D', '#CBCBCB']
  // ]
};



// WEBPACK FOOTER //
// /agir/src/app/utils/utils.ts